import styled from 'styled-components';

export const LanguageChangerStyles = styled('select')`
  all: unset;
  background: transparent;
  font-size: 1rem;
  font-weight: bold;
  color: white;
  border: none;
  text-align: right;
  margin-right: 1rem;
  cursor: pointer;
`;
